import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  SelectProps,
} from "@mui/material";

import conf from "../../conf";
import { User } from "../auth/AuthProvider";
import { useConfgUsers } from "../../hooks/confg/base";

export const SelectEmail = ({
  size,
  value,
  onChange,
  disabled,
}: {
  size?: SelectProps["size"];
  value: string;
  disabled?: boolean;
  onChange: (e: string) => void;
}) => {
  const users = useConfgUsers();

  const handleChange = (event: SelectChangeEvent) =>
    onChange(event.target.value as string);

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel
          id="email-select-label"
          size={size === "small" ? "small" : "normal"}
        >
          Email
        </InputLabel>

        <Select
          id="email-select"
          size={size}
          value={value}
          label="Email"
          labelId="email-select-label"
          disabled={disabled}
          onChange={handleChange}
        >
          {users.data?.data.map((user) => (
            <MenuItem value={user.email}>{user.email}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export const SelectEvent = ({
  role,
  size,
  value,
  onChange,
  disabled,
}: {
  role: User["activeOrganization"]["role"];
  size?: SelectProps["size"];
  value: string;
  disabled?: boolean;
  onChange: (e: string) => void;
}) => {
  const handleChange = (event: SelectChangeEvent) =>
    onChange(event.target.value as string);

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel
          id="event-select-label"
          size={size === "small" ? "small" : "normal"}
        >
          Event
        </InputLabel>

        <Select
          id="event-select"
          size={size}
          value={value}
          label="Event"
          labelId="event-select-label"
          disabled={disabled}
          onChange={handleChange}
        >
          {conf.EVENTS[role].map((event) => (
            <MenuItem value={event}>{event.replaceAll("_", " ")}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export const SelectStatus = ({
  size,
  value,
  options,
  onChange,
  disabled,
}: {
  size?: SelectProps["size"];
  value: string;
  options: string[];
  disabled?: boolean;
  onChange: (e: string) => void;
}) => {
  const handleChange = (event: SelectChangeEvent) =>
    onChange(event.target.value as string);

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel
          id="status-select-label"
          size={size === "small" ? "small" : "normal"}
        >
          Status
        </InputLabel>

        <Select
          id="status-select"
          size={size}
          value={value}
          label="Status"
          labelId="status-select-label"
          disabled={disabled}
          onChange={handleChange}
        >
          {options.map((status) => (
            <MenuItem value={status}>{status}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
